import { useState } from 'react';

import { amplitudeLogEvent } from '@flow/libs/client-analytics/amplitude';
import Button from '@app/components/button';
import { AiInsightsModal } from '@app/components/modals/ai-insights';
import { chartTypes } from '@app/components/pages/ai-insights/constants';
import { getInsightTexts } from '@app/components/pages/ai-insights/texts';
import type { ChartType } from '@app/components/pages/ai-insights/types';
import { T } from '@app/components/translation';
import TooltipInfo from '@app/components/tooltip-info';

import style from './number-chart.module.scss';

type Props = {
  number: number;
  insightType: ChartType;
  hasIssues: boolean;
};

export const NumberChart = ({ number, insightType, hasIssues }: Props) => {
  const [modalVisible, setModalVisible] = useState(false);
  const insightsTexts = getInsightTexts();
  const texts = insightsTexts[insightType];
  const { insightTitle: title, insightTooltip: tooltipText } = texts || {};
  const { chartName } = chartTypes[insightType];

  const handleShowIssueListClick = () => {
    setModalVisible(true);
    amplitudeLogEvent('Go To AI Insights Contract List', {
      'chart type': chartName,
      location: 'ai insights tab - show all button',
    });
  };

  return (
    <>
      <section className={style.NumberChart}>
        <span className={style.Number}>{number}</span>
        <div className={style.TitleWrapper}>
          <h1 className={style.Title}>{title}</h1>
          {hasIssues && (
            <Button
              customClass={style.ChartButton}
              onClick={handleShowIssueListClick}
            >
              <T
                _str="Show documents"
                _comment="Text in the button to show the list of documents"
              />
            </Button>
          )}
        </div>
        <TooltipInfo message={tooltipText} />
      </section>
      {modalVisible && (
        <AiInsightsModal
          clickedInsightType={{
            key: insightType.toLowerCase(),
            value: title,
          }}
          onClose={() => setModalVisible(false)}
          issuesOnly
        />
      )}
    </>
  );
};
